import { FC } from 'react';
import { CreditCardPaymentMethodFieldsFragment } from 'lib/graphql';

type FormattedCreditCardProps = Pick<CreditCardPaymentMethodFieldsFragment, 'cardType' | 'lastFourDigits'>;

const FormattedCreditCard: FC<FormattedCreditCardProps> = ({ cardType, lastFourDigits }) => (
  <>
    {cardType ? cardType : 'credit card'} ending in {lastFourDigits}
  </>
);

export default FormattedCreditCard;
